import { filterCategories } from 'src/common/boatCategories';

/**
 * Looks up which category groups are fully represented by a given set of category ids.
 *
 * Incomplete groups are ignored.
 * @param catIds An array of category ids coming from a url query string.
 * @returns The group ids that are fully represented within the given set.
 */
const reverseLookupCategoryGroupMapping = (catIds: string[]): string[] => {
  const selectedGroupIds = [];

  for (const [groupCatId, ids] of Object.entries(
    filterCategories as Record<string, readonly string[]>,
  )) {
    if (ids.every((id) => catIds.includes(id))) {
      selectedGroupIds.push(groupCatId);
    }
  }
  return selectedGroupIds;
};

export default reverseLookupCategoryGroupMapping;
